import classNames from 'classnames';
import { ReactElement, useCallback } from 'react';
import { ModalOptions, useModal } from 'yoso';

export const useBottomSheet = () => {
  const { open: openModal, ...rest } = useModal();
  const open = useCallback(
    (content: ReactElement, options?: ModalOptions) =>
      openModal(content, {
        ...options,
        componentName: classNames('bottom-sheet-modal', options?.componentName),
      }),
    [openModal]
  );
  return {
    open,
    ...rest,
  };
};
